module.exports = __webpack_public_path__ + "img/tylenol_cold_flu_severe.d0b62a90.jpg";